<template>
  <div class="calender-schedule-tag-component">
    <hi-dialog class="media-dialog" :title="title" @close="close()">
      <div class="tag-group-container">
        <div
          class="tag-people-container"
          :class="{ active: currentIndex === index }"
          v-for="(img, index) in images"
          :key="img.url"
        >
          <media-crop-thumbnails
            class="crop-image"
            :cover="false"
            :model="img"
          ></media-crop-thumbnails>
          <tag-people-group
            :type="type"
            v-if="img.type === 1"
            :tags="tags"
            class="tag-people"
            :image="img"
          ></tag-people-group>
        </div>
      </div>
      <div v-show="images.length > 1" class="switch-container">
        <div
          v-for="(img, index) in images"
          :key="img.url"
          class="point"
          :class="{ active: currentIndex === index }"
          @click="currentImage = img.url"
        ></div>
      </div>
      <div
        class="tip-container"
        v-for="(img, index) in images"
        :key="img.url"
        v-show="currentIndex === index"
      >
        <div class="tip-image" v-if="img.type === 1">
          <div>{{ bottomText1 }}</div>
          <div>Tag to remove.</div>
        </div>
        <!--如果为pruduct 视频是不能添加tag的-->
        <video-tag-people
          :tags="tags"
          :video="img"
          v-if="img.type === 2 && type !== 'product'"
        ></video-tag-people>
      </div>
      <div class="bulk-bottom-container" v-show="only">
        <hi-button class="bulk-save-btn" @click.native="saveClick"
          >Done</hi-button
        >
      </div>
    </hi-dialog>
  </div>
</template>
<style lang="less" scoped>
@import "../../../../assets/style/theme";

.calender-schedule-tag-component {
  .media-dialog {
    width: 374px;
    margin-left: 5px;
    height: 730px;

    .tag-group-container {
      position: relative;
      width: 374px;
      height: 374px;
      background: #e5e5e5;

      .tag-people-container {
        position: absolute;
        left: 0;
        top: 0;

        &.active {
          z-index: 301;
        }

        .crop-image {
          width: 374px;
          height: 374px;
        }

        .tag-people {
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    }

    .switch-container {
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: center;

      &.video {
        height: 20px;
      }

      .point {
        width: 7px;
        height: 7px;
        background: #e62b55;
        border-radius: 50%;
        cursor: pointer;
        margin: 0 5px;
        opacity: 0.24;

        &.active {
          opacity: 1;
        }
      }
    }

    .tip-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .tip-image {
        text-align: center;
        color: @font-color-gray;
        line-height: 24px;
        font-size: 18px;
        font-weight: 300;
      }
    }
    .bulk-bottom-container {
      height: 64px;
      border-top: 1px solid #e6e6e6;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      background: white;
      padding: 0 20px;
      .bulk-save-btn {
        width: 98px;
        height: 36px;
      }
    }
  }
}
</style>

<script>
import hiDialog from "../../../common/dialog/Index.vue";
import MediaCropThumbnails from "../../crop/Thumbnail";
import tagPeopleGroup from "../../../common/tag/Group";
import VideoTagPeople from "./VideoTagPeople";
import hiButton from "../../../common/button/Index";
import { permissionValidate } from "../../../../service/publisher";
import { mapGetters } from "vuex";
import { CURRENT_PUBLISHER_SIMPLE } from "../../../../store/mutation-types";
export default {
  name: "CalenderScheduleTagComponent",
  components: {
    hiButton,
    VideoTagPeople,
    hiDialog,
    MediaCropThumbnails,
    tagPeopleGroup,
  },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    tags: {
      type: Array,
      default: () => [],
    },
    type: {
      // tag_product 和 tag_people公用了一个控件 people 为tag people product为tag_pruduct
      type: String,
      default: "people",
    },
  },
  computed: {
    ...mapGetters({
      currentPublisher: CURRENT_PUBLISHER_SIMPLE,
    }),
    only() {
      return !this.$parent.showMainFormModal;
    },
    /**
     * 获取当前登录人权限
     */
    permission() {
      return this.currentPublisher.permissions;
    },
    /**
     * tag people 和add location 权限
     */
    taggingPermission() {
      return this.permission.tagging;
    },
    /**
     * 标题
     */
    title() {
      if (this.type === "people") {
        return "Tag People";
      } else if (this.type === "product") {
        return "Tag Product";
      }
    },
    bottomText1() {
      if (this.type === "people") {
        return "Tap photo to tag people.";
      } else if (this.type === "product") {
        return "Tap photo to tag products.";
      }
    },
    currentIndex() {
      const index = this.images.findIndex((i) => i.url === this.currentImage);
      if (index === -1) {
        return 0;
      } else {
        return index;
      }
    },
  },
  methods: {
    async saveClick() {
      // 验证tag people 权限
      if (!this.taggingPermission) {
        await permissionValidate({ type: "full" });
        return;
      }
      this.$parent.info.images = this.$parent.images;
      this.$parent.close();
    },
    /**
     * 关闭点击事件
     */
    close() {
      if (this.only) {
        this.$parent.close();
      }
      this.$parent.showTagPeopleModal = false;
      this.$parent.showTagProductModal = false;
    },
  },
  data() {
    return {
      currentImage: this.images[0].url,
    };
  },
  created() {
    this.currentImage = this.images[0].url;
  },
};
</script>
